export const SITE_SETTINGS_STORE = {
  GETTERS: {
    GET_VAT_LOADING: 'SiteSettings/getVatLoading',
    GET_VAT: 'SiteSettings/getVat',
  },
  ACTIONS: {
    FETCH_VAT: 'SiteSettings/fetchVat',
  },
};
